import { Box, Card, CardContent, CircularProgress, Typography } from "@mui/material";
import { GT_COLORS } from "../../../../constants/designTokens.constants";

interface Props {
    count: number | null;
    loading: boolean;
    activeFilter?: 'active' | 'inactive' | 'all';
}

export const RecipientStatsBar: React.FC<Props> = ({ count, loading, activeFilter = 'all' }) => {
    const filterLabel = activeFilter === 'active' ? 'mobile app ' : activeFilter === 'inactive' ? 'no mobile app ' : '';

    return (
        <Card
            elevation={0}
            sx={{
                mb: 4,
                backgroundColor: GT_COLORS.greenLight,
                border: `1px solid ${GT_COLORS.green}`,
                borderRadius: 2.5,
            }}
        >
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {loading ? (
                        <>
                            <CircularProgress size={16} sx={{ color: GT_COLORS.green }} />
                            <Typography variant="body1" sx={{ color: GT_COLORS.textPrimary }}>
                                Calculating recipients...
                            </Typography>
                        </>
                    ) : count !== null ? (
                        <Typography variant="body1" sx={{ color: GT_COLORS.textPrimary }}>
                            You have selected <strong>{count} {filterLabel}POM Users</strong> as part of this message campaign.
                        </Typography>
                    ) : (
                        <Typography variant="body1" sx={{ color: GT_COLORS.textMuted }}>
                            Unable to determine recipient count
                        </Typography>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};
